// No imports: bootstrap must remove bearer links before loading the app or SDKs.
export type AuthLinkKind = "invitation" | "activation" | "reset" | "signup";
export interface AuthLink { token?: string; invalid: boolean }
let captured: { kind: AuthLinkKind; link: AuthLink; path: string } | undefined;

function authPath(pathname: string): string {
  // Router paths are case-insensitive, decoded and accept trailing slashes.
  // decodeURI preserves encoded separators; they must not create new routes.
  try { return decodeURI(pathname).toLowerCase().replace(/\/+$/, "") || "/"; }
  catch { return pathname; }
}

export function captureAuthLink(): void {
  const { pathname, hash, search } = window.location;
  const path = authPath(pathname);
  const kind = path === "/activate" ? "activation"
    : path === "/reset-password" ? "reset"
    : path === "/signup" ? "signup"
    : path === "/login" ? "invitation" : undefined;
  const key = kind === "invitation" ? "invitation" : "token";
  const fragment = new URLSearchParams(hash.slice(1));
  const query = new URLSearchParams(search);
  const querySecret = query.has("token") || query.has("invitation");
  const fragmentSecret = fragment.has("token") || fragment.has("invitation");
  if (!hash && !querySecret && captured?.path === path) return;
  query.delete("token");
  query.delete("invitation");
  if ((kind && hash) || fragmentSecret || querySecret) {
    const safeSearch = query.toString();
    window.history.replaceState(window.history.state, "", pathname + (safeSearch ? `?${safeSearch}` : ""));
  }
  if (!kind) { captured = undefined; return; }
  const token = fragment.get(key);
  const valid = !querySecret && fragment.size === 1 && !!token && /^[A-Za-z0-9_-]{43}$/.test(token);
  captured = { kind, path, link: valid ? { token, invalid: false }
    : { invalid: (kind !== "invitation" && kind !== "signup") || !!hash || querySecret } };
}

export function readAuthLink(kind: AuthLinkKind): AuthLink {
  captureAuthLink();
  return captured?.kind === kind && captured.path === authPath(window.location.pathname)
    ? captured.link : { invalid: kind !== "invitation" && kind !== "signup" };
}

export function clearAuthLink(): void { captured = undefined; }
